import React, {lazy, Suspense} from 'react'

const LiturgiesPageLazy = lazy(() =>
    import('./LiturgiesPage')
)

const LiturgiesPage = props => (
    <Suspense fallback={null}>
        <LiturgiesPageLazy {...props} />
    </Suspense>
)

export default LiturgiesPage
